<dx-popup #dlgOpenTill [width]="450" [height]="250" [showTitle]="true" title="Enter Till Float" [resizeEnabled]=true
    [dragEnabled]="true" [showCloseButton]="false" [hideOnOutsideClick]="false">
    <dxi-toolbar-item widget="dxButton" toolbar="bottom" location="after" [options]="OKButtonOptions">
    </dxi-toolbar-item>
    <div *dxTemplate="let data of 'content'">
        <dx-form [formData]="floatInfo">
            <dxi-item dataField="TerminalName" caption="Terminal Name" editorType="dxTextBox"
                [editorOptions]="{ readOnly:true}">
            </dxi-item>

            <dxi-item dataField="CashFloatTotal" caption="Cash Float Total" editorType="dxNumberBox"
                [editorOptions]="{ format:'£#,##0.00', min:'0.0', max:'99999.99', showSpinButtons:true, showClearButton:true }">
            </dxi-item>
        </dx-form>
    </div>
</dx-popup>